import type { NestedI18nObject } from '../../utils';

const searchTable: NestedI18nObject = {
  // 搜索表格页面
  createForm: {
    newRule: '新建规则',
  },
  updateForm: {
    ruleConfig: '规则配置',
    basicConfig: '基本信息',
    ruleName: {
      nameLabel: '规则名称',
      nameRules: '请输入规则名称！',
    },
    ruleDesc: {
      descLabel: '规则描述',
      descPlaceholder: '请输入至少五个字符',
      descRules: '请输入至少五个字符的规则描述！',
    },
    ruleProps: {
      title: '配置规则属性',
      templateLabel: '规则模板',
      typeLabel: '规则类型',
    },
    object: '监控对象',
    schedulingPeriod: {
      title: '设定调度周期',
      timeLabel: '开始时间',
      timeRules: '请选择开始时间！',
    },
  },
  titleDesc: '描述',
  ruleName: '规则名称为必填项',
  titleCallNo: '服务调用次数',
  titleStatus: '状态',
  nameStatus: {
    default: '关闭',
    running: '运行中',
    online: '已上线',
    abnormal: '异常',
  },
  titleUpdatedAt: '上次调度时间',
  exception: '请输入异常原因！',
  titleOption: '操作',
  config: '配置',
  subscribeAlert: '订阅警报',
  title: '查询表格',
  new: '新建',
  chosen: '已选择',
  item: '项',
  totalServiceCalls: '服务调用次数总计',
  tenThousand: '万',
  batchDeletion: '批量删除',
  batchApproval: '批量审批',
};

export default searchTable;
